<template>
  <div id="organization-admin-link-screen" class="hospital-members__modal-content">
    <div class="organization-admin-association-response-message" v-if="isResponseMessageVisible">
      <label>{{ getResponseMessage }}</label>
    </div>
    <table class="organization-admin-association-table">
      <tr>
        <td><label>Give</label></td>
        <td>
          <select id="organization-admin-association-table__select-role" v-model="role" v-on:change="onRoleSelected">
            <option value="members">Member</option>
            <option value="administrators">Administrator</option>
          </select>
        </td>
        <td><label>access to</label></td>
        <td>
          <select id="organization-admin-association-table__select-user-type" v-model="userType" @change="onUserTypeSelected">
            <option value="existing">Select ...</option>
            <option value="new">a new user</option>
          </select>
        </td>
        <td>
          <!--
          <autocomplete
            v-if="userType === 'existing'"
            :url="suggestionUrl"
            param="text"
            anchor="email"
            name="autocomplete"
            label="displayName"
            :customHeaders="jwtToken"
            :classes="{ input: 'form-control', list: 'hospital-members__autocomplete-list', wrapper: 'input-wrapper'}"
            :process="processJSON"
            :onSelect="handleSelect"
            :onInput="handleAutocompleteInput"
          >
          </autocomplete>
          -->
        </td>
      </tr>
    </table>

    <button
      type="button"
      id="organization-admin-association__add-button"
      class="btn btn-default"
      :disabled="!isUserReadyToLink"
      v-if="userType === 'existing'"
      @click="associateUserWitHospital"
    >
      <span class="glyphicon glyphicon-plus"></span> Add
    </button>
    <organization-admin-add-form v-if="isAddFormVisible" />
  </div>
</template>

<script>
import 'vue2-autocomplete-js/dist/style/vue2-autocomplete.css';
import Vue from 'vue';
import Vuex from 'vuex';
import VueFormGenerator from 'vue-form-generator';
import Autocomplete from 'vue2-autocomplete-js';

import OrganizationAdminAddForm from '../OrganizationAdminAddForm/OrganizationAdminAddForm';

import tokenFormatter from '../../formatters/token.formatter';

import computed from './organizationAdminLinkScreen.computed';
import methods from './organizationAdminLinkScreen.methods';

const JWT_KEY = 'ngStorage-tokenJWT';
const storedToken = localStorage.getItem(JWT_KEY) || sessionStorage.getItem(JWT_KEY);

Vue.use(Vuex);
Vue.use(VueFormGenerator);

Vue.component('autocomplete', Autocomplete);
Vue.component('organization-admin-add-form', OrganizationAdminAddForm);

export default {
  name: 'OrganizationAdminLinkScreen',
  methods,
  computed,
  data: () => ({
    role: 'members',
    userId: '',
    jwtToken: {
      Authorization: `JWT ${tokenFormatter.format(storedToken)}`,
    },
    suggestionUrl: `${CONFIG.BASE_URL_V4}/users/suggestions`,
  }),
};
</script>

<style scopped>
td {
  padding: 15px;
}
.hospital-members__autocomplete-list > ul {
  z-index: 9999;
}
.hospital-members__modal-content {
  margin: 0 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrganizationAdminLinkScreen/OrganizationAdminLinkScreen.vue